<template>
    <div
        class="container myWeflixEditVideo page-card w-100 edit-video-page"
        data-aos="fade-left"
        data-aos-duration="1500"
    >
        <header class="edit-video-header">
            <div class="edit-video-header__lead">
                <TitlePage
                    title="Editar Vídeo"
                    subtitle="Edite um vídeo para sua coleção"
                    :hasMargin="false"
                />
            </div>
            <div class="edit-video-actions" role="toolbar" aria-label="Ações do vídeo">
                <button
                    type="button"
                    class="edit-video-icon-btn"
                    title="Mover para outra coleção"
                    @click="showMoveDialog = true"
                >
                    <fa icon="fa-folder-open" />
                    <span class="edit-video-icon-btn__label">Mover</span>
                </button>
                <button
                    type="button"
                    class="edit-video-icon-btn"
                    title="Reutilizar em outra coleção"
                    @click="showCopyDialog = true"
                >
                    <fa icon="fa-recycle" />
                    <span class="edit-video-icon-btn__label">Reutilizar</span>
                </button>
                <button
                    type="button"
                    class="edit-video-icon-btn edit-video-icon-btn--danger"
                    title="Excluir vídeo"
                    @click="showConfirmDialog = true"
                >
                    <fa icon="fa-trash" />
                    <span class="edit-video-icon-btn__label">Excluir</span>
                </button>
            </div>
        </header>

        <div class="edit-video-shell" v-if="hasReady">
            <main class="edit-video-main">
                <section class="edit-video-panel edit-video-panel--form">
                    <h4 class="edit-video-panel__title">Dados do vídeo</h4>
                    <div class="edit-video-grid-2">
                        <div class="form-group">
                            <div class="form-label">
                                <label>Status</label>
                            </div>
                            <div class="form-input">
                                <select class="form-control" v-model="status">
                                    <option :value="true">Ativado</option>
                                    <option :value="false">Desativado</option>
                                </select>
                                <p v-if="Number(lessonStatus) === 5 && status" class="cover-edit-hint status-processing-hint">
                                    Processando
                                </p>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="form-label">
                                <label>Visibilidade</label>
                            </div>
                            <div class="form-input">
                                <select class="form-control" v-model="sample">
                                    <option :value="true">Gratuito</option>
                                    <option :value="false">Pago</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="form-label">
                            <label>Título do vídeo</label>
                        </div>
                        <div class="form-input">
                            <input
                                type="text"
                                required
                                class="form-control"
                                v-model="name"
                                placeholder="Título exibido na coleção"
                            />
                        </div>
                    </div>
                    <div class="form-group edit-video-description">
                        <div class="form-label">
                            <label>Descrição do vídeo</label>
                        </div>
                        <div class="form-textarea edit-video-description__field">
                            <textarea
                                class="form-control"
                                v-model="shortDescription"
                                maxlength="300"
                                placeholder="Descrição do vídeo"
                            ></textarea>
                        </div>
                        <small class="char-counter"
                            >{{ (shortDescription || '').length }}/300 caracteres</small
                        >
                    </div>
                </section>
            </main>

            <aside class="edit-video-aside">
                <section class="edit-video-panel edit-video-panel--media">
                    <h4 class="edit-video-panel__title">Pré-visualização</h4>
                    <div v-if="videoPlayer && !replaceVideo && !path">
                        <div class="edit-video-player">
                            <iframe
                                :src="videoPlayer"
                                title="Pré-visualização do vídeo"
                                width="100%"
                                frameborder="0"
                                allow="autoplay; fullscreen"
                                allowfullscreen
                            ></iframe>
                        </div>
                        <button
                            type="button"
                            class="edit-video-replace"
                            @click="replaceVideo = true"
                        >
                            Substituir vídeo
                        </button>
                    </div>
                    <div class="edit-video-file-upload" v-else>
                        <VideoUploadInput
                            label="Arquivo do vídeo"
                            :preview-url="path"
                            accept=".mp4, .mov, .webm, .avi"
                            accept-text="Envie o arquivo e salve para o player ficar disponível"
                            placeholder="Clique para enviar o vídeo"
                            :disabled="isUploading"
                            :uploading="isUploading"
                            :progress="progress"
                            @file-selected="handleVideoSelected"
                            @remove-preview="handleVideoRemove"
                        />
                    </div>
                    <div class="edit-video-upload-wrap">
                        <ImageUploadInput
                            label="Capa do vídeo"
                            :preview-url="imagePreviewCover"
                            :accept="'.png, .jpg, .jpeg, .webp'"
                            accept-text="Tamanho: 400x400px, apenas formato PNG e JPG"
                            placeholder="Clique para fazer upload de imagem"
                            :disabled="!loaderImage"
                            @file-selected="handleImageSelected"
                            @remove-preview="handleImageRemove"
                        />
                        <p v-if="imagePreviewCover" class="cover-edit-hint">
                            Esta capa poderá ser editada na edição do vídeo.
                        </p>
                    </div>
                </section>
            </aside>

        </div>

        <footer class="edit-video-footer">
            <v-btn
                variant="outlined"
                color="primary"
                size="large"
                border="2"
                class="text-none"
                @click="() => $router.push('/admin/colecao/' + currentCollections.id)"
                >Voltar</v-btn
            >
            <v-btn
                variant="flat"
                color="primary"
                size="large"
                class="text-none"
                @click="editVideo()"
                :disabled="!loaderImage"
                :class="{ disabled: !loaderImage }"
                >Salvar</v-btn
            >
        </footer>
    </div>
    <div class="pa-4 text-center" style="padding: 0px!important;">
        <v-dialog
            v-model="showConfirmDialog"
            max-width="320"
            persistent
            class="confirm-dialog-delete"
        >
            <v-card>
                <v-card-title class="headline">Atenção</v-card-title>
        
                <v-card-text>
                    Deseja realmente excluir este vídeo?
                    
                </v-card-text>
        
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="cancel" text @click="showConfirmDialog = false">Sair</v-btn>
                    <v-btn class="accept" text @click="confirmDisable">Deletar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>

    <v-dialog v-model="showMoveDialog" max-width="600" class="move-video-dialog">
        <v-card>
            <v-card-title>Mover Vídeo</v-card-title>
            <v-card-text>
                <div class="video-info">
                    <div class="video-thumbnail">
                        <img :src="imagePreviewCover" :alt="name">
                    </div>
                    <div class="video-details">
                        <h3>{{ name }}</h3>
                        <p class="duration">Duração: {{ videoTime ? converterTempo(videoTime) : '00:00' }}</p>
                    </div>
                </div>
    
                <div class="move-controls">
                    <p>Para qual coleção deseja mover este vídeo?</p>
                    <select v-model="selectedCollection" class="form-select">
                        <option value="">Selecione uma coleção</option>
                        <option v-for="collection in collections" 
                                :key="collection.id"
                                :value="collection.id">
                            {{ collection.name }}
                        </option>
                    </select>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="showMoveDialog = false">Cancelar</v-btn>
                <v-btn color="primary" text :disabled="!selectedCollection" @click="moveVideo">Mover</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    

    <v-dialog v-model="showCopyDialog" max-width="600" class="copy-video-dialog">
        <v-card>
            <v-card-title>Copiar Vídeo</v-card-title>
            <v-card-text>
                <div class="move-controls">
                    <p>Selecione a coleção de origem</p>
                    <select v-model="selectedCollection" class="form-select" @change="putIdReuseVideoCollection">
                        <option value="">Selecione uma coleção</option>
                        <option v-for="collection in collections" 
                                :key="collection.id"
                                :value="collection.id">
                            {{ collection.name }}
                        </option>
                    </select>
                </div>
            </v-card-text>
            <v-card-text>
                <div class="move-controls">
                    <p>Selecione o vídeo</p>
                    <select v-model="selectedLesson" class="form-select">
                        <option value="">Selecione um vídeo</option>
                        <option v-for="videos in videosList" 
                                :key="videos.id"
                                :value="videos.id">
                            {{ videos.name }}
                        </option>
                    </select>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="showCopyDialog = false">Cancelar</v-btn>
                <v-btn color="primary" text @click="copyVideo">Copiar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <Loader :hasReady="hasReady"/>
</template>
<script>
import Sesson from '@/utils/Weflix/sesson';
import Videos from '@/utils/Weflix/videos';
import { mapState } from 'vuex';
import Loader from '@/components/Weflix/Loader';
import apiAWS from '@/utils/storage/aws';
import companyApi from '@/utils/Weflix/company';
import LoaderImage from '@/components/Weflix/LoaderImage';
import PlayerVideo from '@/utils/storage/playerVideo';
import ImageUploadInput from '@/components/Weflix/ImageUploadInput.vue';
import VideoUploadInput from '@/components/Weflix/VideoUploadInput.vue';
import { toast } from 'vue3-toastify';
import TitlePage from '@/components/Weflix/titlePage.vue';

export default {
    data() {
        return {
            deleteItem: false,
            showConfirmDialog: false,
            season: '',
            seasonSelected: null,
            noSeason: true,
            status: false,
            lessonStatus: null,
            sample: false,
            name: '',
            shortDescription: '',
            videoFile: null,
            coverVideo: '',
            imagePreviewCover: '',
            linkVideo: '',
            path: null,
            hasReady: false,
            loaderImage: true,
            videoPlayer: '',
            hasVideotecaPath: false,
            replaceVideo: false,
            lessonMedia: {
                path: null,
                fileId: null,
                callbackUrl: null,
                uploadId: null,
                parts: null,
                filename: null,
                mediaType: null,
                size: null,
                thumbnailUploaded: null,
                token: null,
            },
            tokenVideo: '',
            videotecaUpload: {
                fileId: null,
                callbackUrl: null,
                uploadId: null,
                parts: [],
                filename: null,
                mediaType: null,
                size: 0,
                thumbnailUploaded: false,
                thumbnailUploadUrl: null,
            },
            videotecaFolderId: null,
            isUploading: false,
            uploadProgress: 0,
            isUploaded: false,
            longDescription: '',
            progress: 0,
            showMoveDialog: false,
            selectedVideo: null,
            selectedCollection: '',
            collections: [],
            showCopyDialog: false,
            lessonByCollection: [
                { id: 1, name: 'Video 1' },
                { id: 2, name: 'Video 2' },
                { id: 3, name: 'Video 3' }
            ],
            selectedLesson: null,
            filterText: '',
            filteredCollections: [],
            idReuseVideoCollection: null,
            videosList: [],
            videoTime: null
        };
    },
    computed: {
        ...mapState(['token', 'currentCollections']),
        filteredCollections() {
            if (!this.filterText) return this.collections;
            return this.collections.filter(item =>
                item.name.toLowerCase().includes(this.filterText.toLowerCase())
            );
        }
    },
    components: {
        ImageUploadInput,
        VideoUploadInput,
        Loader,
        LoaderImage,
        TitlePage
    },
    methods: {
        notify(message, type = "info") {
            toast(message, {
                autoClose: 3000,
                position: 'top-right',
                theme: "light",
                limit: 1,
                type: type,
                dangerouslyHTMLString: true
            });
        },
        confirmDisable() {
            this.showConfirmDialog = false;
            this.disableVideo();
        },
        closeDialog() {
            this.deleteItem = false;
        },
        handleImageSelected(file, event) {
            this.updateFileCover(event);
        },
        handleImageRemove() {
            if (this.imagePreviewCover) {
                URL.revokeObjectURL(this.imagePreviewCover);
                this.imagePreviewCover = '';
            }
        },
        handleVideoSelected(file, event) {
            this.uploadVideoAws(event);
        },
        handleVideoRemove() {
            if (this.path) {
                URL.revokeObjectURL(this.path);
                this.path = null;
            }
            this.isUploaded = false;
            this.isUploading = false;
            this.progress = 0;
            this.videotecaUpload = {
                fileId: null,
                callbackUrl: null,
                uploadId: null,
                parts: [],
                filename: null,
                mediaType: null,
                size: 0,
                thumbnailUploaded: false,
                thumbnailUploadUrl: null,
            };
        },
        updateFileCover(event) {
            const file = event.target.files[0];
            if (file) {
                this.imagePreviewCover = URL.createObjectURL(file);
            }
        },
        updateFilePathThumbnail(event) {
            this.videoFile = event.target.files[0];
        },
        updateContentLongDescription(content) {
            this.longDescription = content;
        },
        seasonsListFromApi(response) {
            if (Array.isArray(response)) return response;
            if (response?.content != null) return response.content;
            if (response?.list != null) return response.list;
            return [];
        },
        async getSesson() {
            if (!this.currentCollections?.id) return;
            try {
                const response = await Sesson.getSessonByCollection(
                    this.token,
                    this.currentCollections.id
                );
                const list = this.seasonsListFromApi(response);
                this.hasReady = true;
                if (list.length > 0) {
                    this.season = [...list].sort(
                        (a, b) => (a.order ?? 0) - (b.order ?? 0)
                    );
                    this.seasonSelected = this.season[0].id;
                    this.noSeason = false;
                } else {
                    this.noSeason = true;
                    this.newSeason();
                }
            } catch (error) {
                console.error('Erro ao obter dados da coleção:', error);
            }
        },
        putIdReuseVideoCollection() {
            this.idReuseVideoCollection = this.selectedCollection;
            this.getLessonByCollections();
        },
        async getLessonByCollections() {
            try {
                const response = await Videos.listLessonByCollections(this.token, this.idReuseVideoCollection);
                this.videosList = response;
            } catch (error) {
                console.error('Erro ao obter aulas:', error);
            }
        },
        async getSessonBy() {
            if (!this.currentCollections?.id) return;
            try {
                const response = await Sesson.getSessonByCollection(
                    this.token,
                    this.currentCollections.id
                );
                const list = this.seasonsListFromApi(response);
                this.hasReady = true;
                if (list.length > 0) {
                    this.season = [...list].sort(
                        (a, b) => (a.order ?? 0) - (b.order ?? 0)
                    );
                    this.seasonSelected = this.season[0].id;
                    this.noSeason = false;
                } else {
                    this.noSeason = true;
                    this.newSeason();
                }
            } catch (error) {
                console.error('Erro ao obter dados da coleção:', error);
            }
        },
        async newSeason() {
            const payload = {
                course: {
                    id: this.currentCollections.id
                },
                title: "Temporada 1",
                sample: 0
            };
            try {
                await Sesson.createSesson(this.token, payload);
            } catch (error) {
                console.error('Erro ao criar temporada:', error);
            }
        },
        async getVideo() {
            const param = this.$route.params.slug;
            try {
                const response = await Videos.getVideosById(this.token, param);
                this.lessonStatus = Number(response.status);
                this.status = this.lessonStatus === 1 || this.lessonStatus === 5;
                this.sample = response.sample == 1 ? true : false;
                this.name = response.title;
                this.shortDescription = response.description;
                this.videoFile = response.path;
                this.hasVideotecaPath = Boolean(response.path || response.fileId);
                this.lessonMedia = {
                    path: response.path ?? null,
                    fileId: response.fileId ?? null,
                    callbackUrl: response.callbackUrl ?? null,
                    uploadId: response.uploadId ?? null,
                    parts: response.parts ?? null,
                    filename: response.filename ?? null,
                    mediaType: response.mediaType ?? null,
                    size: response.size ?? null,
                    thumbnailUploaded: response.thumbnailUploaded ?? null,
                    token: response.token ?? null,
                };
                const thumb =
                    response.finalVideoThumbnail ||
                    response.videoThumbnail ||
                    '';
                this.coverVideo =
                    thumb && String(thumb).includes('.com/')
                        ? String(thumb).split('.com/')[1]
                        : String(thumb || '');
                this.seasonSelected = response.idModule;
                this.imagePreviewCover =
                    response.finalVideoThumbnail ||
                    response.videoThumbnail ||
                    '';
                this.hasReady = true;
                this.videoTime = response.videoTime;
                await this.loadPreviewPlayer();
            } catch (error) {
                console.error('Erro ao obter dados do video:', error);
            }
        },
        converterTempo(segundos) {
            const minutos = Math.floor(segundos / 60);
            const segundosRestantes = segundos % 60;
            const segundosFormatados = segundosRestantes.toString().padStart(2, '0');
            return `${minutos}:${segundosFormatados}s`;
        },
        async putFileAws(url, file) {
            try {
                await apiAWS.putFileAWS(url, file);
            } catch (error) {
                console.error('Erro ao enviar arquivo para AWS');
            }
        },
        async updateFileCover(event) {
            this.loaderImage = false;
            const file = event.target.files[0];
            this.imagePreviewCover = URL.createObjectURL(file);
            try {
                const thumbUrl = this.videotecaUpload?.thumbnailUploadUrl;
                if (thumbUrl) {
                    await this.putFileAws(thumbUrl, file);
                    this.videotecaUpload.thumbnailUploaded = true;
                    this.coverVideo = null;
                } else {
                    const response = await apiAWS.getSignatureImage(this.token, file.name);
                    await this.putFileAws(response.url, file);
                    this.coverVideo = response.token;
                }
                this.loaderImage = true;
            } catch (error) {
                console.error('Erro ao enviar capa', error);
                this.loaderImage = true;
            }
        },
        async ensureVideotecaFolderId() {
            if (this.videotecaFolderId) return this.videotecaFolderId;
            const status = await companyApi.getVideoteca(this.token);
            const folderId = status?.folderId || status?.idFolder || status?.idFolderVideoteca || null;
            if (!folderId) throw new Error('VIDEOTECA_FOLDER_MISSING');
            this.videotecaFolderId = String(folderId);
            return this.videotecaFolderId;
        },
        async uploadVideoAws(event) {
            try {
                const file = event.target.files[0];
                if (!file) return;
                if (Math.round(file.size / (1024 * 1024)) > 4096) {
                    this.notify('O arquivo passa de 4 GB.', 'error');
                    return;
                }
                this.path = URL.createObjectURL(file);
                this.isUploaded = false;
                this.progress = 0;
                const folderId = await this.ensureVideotecaFolderId();
                const title = (this.name || '').trim() || file.name.replace(/\.[^.]+$/, '') || file.name;
                const initResponse = await apiAWS.initVideotecaUpload(this.token, {
                    filename: file.name,
                    mediaType: file.type || 'video/mp4',
                    folderId,
                    title,
                    size: file.size,
                    metadata: {},
                });
                if (!initResponse) throw new Error('URLs de upload inválidas');
                const data = initResponse.data || initResponse;
                const multipart = data.multipart || null;
                const partUrls = Array.isArray(multipart?.partUrls)
                    ? [...multipart.partUrls].sort((a, b) => Number(a.partNumber) - Number(b.partNumber))
                    : [];
                const uploadId = multipart?.uploadId || data.uploadId || initResponse.uploadId || null;
                if (partUrls.length > 0 && !uploadId) {
                    throw new Error('Init multipart sem uploadId — não é possível finalizar o upload.');
                }
                this.videotecaUpload = {
                    fileId: data.fileId || null,
                    callbackUrl: data.callbackUrl || null,
                    uploadId,
                    partUrls,
                    partSize: Number(multipart?.partSize) || 0,
                    fileUploadUrl: data.fileUploadUrl || null,
                    thumbnailUploadUrl: data.thumbnailUploadUrl || null,
                    filename: file.name,
                    mediaType: file.type || 'video/mp4',
                    size: file.size,
                    parts: [],
                    thumbnailUploaded: false,
                    file,
                };
                await this.putVideoAwsV1(this.videotecaUpload);
            } catch (error) {
                console.error('Erro ao enviar arquivo para a Videoteca', error);
                this.isUploading = false;
                this.isUploaded = false;
                if (error?.message === 'VIDEOTECA_FOLDER_MISSING') {
                    this.notify('A empresa não tem pasta na Videoteca.', 'error');
                }
            }
        },
        async putVideoAwsV1(uploadState) {
            this.isUploading = true;
            this.isUploaded = false;
            const file = uploadState.file;
            const partUrls = uploadState.partUrls || [];
            const parts = [];
            if (partUrls.length > 0) {
                const partSize = Number(uploadState.partSize) || Math.ceil(file.size / partUrls.length);
                const progressArray = new Array(partUrls.length).fill(0);
                for (let i = 0; i < partUrls.length; i += 1) {
                    const part = partUrls[i];
                    const partNumber = Number(part.partNumber) || (i + 1);
                    const start = i * partSize;
                    const end = Math.min(start + partSize, file.size);
                    const response = await apiAWS.putVideoAWS(part.url, file.slice(start, end), (progress) => {
                        progressArray[i] = progress;
                        this.progress = progressArray.reduce((a, b) => a + b, 0) / partUrls.length;
                    });
                    if (!response?.etag) throw new Error(`ETag ausente na parte ${partNumber}`);
                    parts.push({ partNumber, etag: response.etag });
                }
            } else if (uploadState.fileUploadUrl) {
                await apiAWS.putVideoAWS(uploadState.fileUploadUrl, file, (progress) => {
                    this.progress = progress;
                });
            } else {
                throw new Error('URLs de upload inválidas');
            }
            this.videotecaUpload = {
                ...this.videotecaUpload,
                parts: uploadState.uploadId ? parts : [],
            };
            this.isUploaded = true;
            this.isUploading = false;
            this.progress = 100;
        },
        async editVideo() {
            this.hasReady = false;
            const id = this.$route.params.slug;
            const upload = this.videotecaUpload || {};
            const parts = Array.isArray(upload.parts) && upload.parts.length ? upload.parts : null;
            const media = this.lessonMedia || {};
            const lessonPayload = {
                idModule: this.seasonSelected,
                title: this.name,
                description: this.shortDescription,
                videoThumbnail: upload.thumbnailUploaded ? null : this.coverVideo,
                sample: this.sample == true ? 1 : 0,
                type: 6,
                status: this.status == true ? (Number(this.lessonStatus) === 5 ? 5 : 1) : 0,
            };
            ['path', 'fileId', 'callbackUrl', 'uploadId', 'parts', 'filename', 'mediaType', 'size', 'thumbnailUploaded', 'token'].forEach((key) => {
                if (media[key] != null && media[key] !== '') {
                    lessonPayload[key] = media[key];
                }
            });
            if (this.isUploading) {
                this.hasReady = true;
                this.notify('Aguarde o envio do arquivo terminar antes de salvar.', 'error');
                return;
            }
            try {
                if (upload.fileId) {
                    if (!this.isUploaded) {
                        throw new Error('O arquivo ainda não foi enviado para a Videoteca.');
                    }
                    const fileId = upload.fileId;
                    const uploadPayload = {
                        idModule: this.seasonSelected,
                        title: this.name,
                        description: this.shortDescription,
                        fileId,
                        callbackUrl:
                            upload.callbackUrl ||
                            `https://api.videotecaead.com.br/v1/files/${fileId}/complete`,
                    };
                    if (upload.uploadId && parts) {
                        uploadPayload.uploadId = upload.uploadId;
                        uploadPayload.parts = parts;
                    } else if (upload.uploadId || parts) {
                        throw new Error('Upload multipart incompleto: uploadId e parts precisam ir juntos.');
                    }
                    await apiAWS.editVideoVideoteca(this.token, uploadPayload, id);
                    this.hasVideotecaPath = true;
                    this.lessonMedia = {
                        ...media,
                        path: fileId,
                        fileId,
                        callbackUrl: uploadPayload.callbackUrl,
                    };
                    lessonPayload.path = fileId;
                    lessonPayload.fileId = fileId;
                    lessonPayload.callbackUrl = uploadPayload.callbackUrl;
                }
                await Videos.editLesson(this.token, lessonPayload, id);
                if (lessonPayload.fileId || lessonPayload.path) {
                    await this.loadPreviewPlayer();
                }
                if (upload.fileId) {
                    this.handleVideoRemove();
                    this.replaceVideo = false;
                }
                this.hasReady = true;
                if (!this.hasVideotecaPath && !this.videoPlayer) {
                    this.notify(
                        'Dados da aula salvos. Envie o arquivo de vídeo e salve de novo para o player funcionar.',
                        'warning'
                    );
                } else {
                    this.notify('Vídeo atualizado com sucesso!', 'success');
                }
            } catch (error) {
                this.hasReady = true;
                this.notify('Erro ao editar vídeo: ' + error.message, 'error');
                console.error('Erro ao editar vídeo', error);
            }
        },
        async disableVideo() {
            this.hasReady = false;
            const id = this.$route.params.slug;
            const media = this.lessonMedia || {};
            const payload = {
                idModule: this.seasonSelected,
                title: this.name,
                description: this.shortDescription,
                videoThumbnail: this.coverVideo,
                sample: this.sample == true ? 1 : 0,
                type: 6,
                status: 3
            };
            ['path', 'fileId', 'callbackUrl', 'token'].forEach((key) => {
                if (media[key] != null && media[key] !== '') {
                    payload[key] = media[key];
                }
            });
            try {
                await Videos.editLesson(this.token, payload, id);
                this.hasReady = true;
            } catch (error) {
                console.error('Erro ao desativar vídeo', error);
            } finally {
                this.$router.push('/admin/colecao/' + this.currentCollections.id);
            }
        },
        async loadPreviewPlayer() {
            const id = this.$route.params.slug;
            const media = this.lessonMedia || {};
            if (!id || (!media.fileId && !media.path && !this.hasVideotecaPath)) return;
            try {
                this.videoPlayer = await PlayerVideo.getPlayerVideo(this.token, id);
            } catch (error) {
                console.error('Erro ao obter o player:', error);
            }
        },
        async moveVideo() {
            const id = this.$route.params.slug;
            try {
                await Videos.moveVideo(this.token, id, this.selectedCollection);
                alert('Vídeo movido com sucesso');
                this.showMoveDialog = false;
            } catch (error) {
                console.error('Erro ao mover vídeo:', error);
            }
        },
        async getCollections() {
            try {
                const response = await Videos.listCollections(this.token);
                console.log(response);
                this.collections = response.map(item => ({
                    id: item.id,
                    name: item.name,
                    status: item.status
                }));
            } catch (error) {
                console.error('Erro ao obter coleções:', error);
            }
        }
    },
    created() {
        this.getVideo();
        this.getSesson();
        this.getCollections();
    }
};
</script>

<style scoped>
    .cover-edit-hint {
        margin: 0.75rem 0 0;
        color: #5c6370;
        font-size: 0.8125rem;
        text-align: center;
    }

    .status-processing-hint {
        margin: 0.4rem 0 0;
        text-align: left;
    }

    @import url(./global.css);
    @import url(@/css/weflix/admin/editVideo.css);

    .edit-video-page.container.myWeflixEditVideo.page-card.w-100 {
        width: 100%;
        max-width: 100%;
        background: #f4f5f8;
        border-radius: 16px;
        padding: 0 0 1.5rem;
        box-shadow: 0 1px 3px rgba(37, 8, 145, 0.06);
    }

    .edit-video-header {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        justify-content: space-between;
        gap: 1rem 1.5rem;
        padding: 1.25rem 1.5rem 1rem;
        background: linear-gradient(135deg, #fafbff 0%, #ffffff 100%);
        border-bottom: 1px solid #e8eaf0;
        border-radius: 16px 16px 0 0;
    }

    .edit-video-header__lead {
        flex: 1;
        min-width: 200px;
    }

    .edit-video-actions {
        display: inline-flex;
        flex-wrap: wrap;
        gap: 0.5rem;
        padding: 0.25rem;
        background: #fff;
        border: 1px solid #e8eaf0;
        border-radius: 12px;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
    }

    .edit-video-icon-btn {
        display: inline-flex;
        align-items: center;
        gap: 0.4rem;
        padding: 0.5rem 0.75rem;
        border: none;
        border-radius: 8px;
        background: #eef0fc;
        color: #250891;
        font-size: 0.8125rem;
        font-weight: 500;
        cursor: pointer;
        transition: background 0.2s ease, color 0.2s ease, transform 0.15s ease;
    }

    .edit-video-icon-btn:hover {
        background: #250891;
        color: #fff;
    }

    .edit-video-icon-btn:hover :deep(svg) {
        color: #fff !important;
    }

    .edit-video-icon-btn :deep(svg) {
        width: 1rem !important;
        height: 1rem !important;
        color: #250891;
    }

    .edit-video-icon-btn--danger {
        background: #fff0f0;
        color: #c62828;
    }

    .edit-video-icon-btn--danger :deep(svg) {
        color: #c62828;
    }

    .edit-video-icon-btn--danger:hover {
        background: #c62828;
        color: #fff;
    }

    .edit-video-icon-btn--danger:hover :deep(svg) {
        color: #fff !important;
    }

    .edit-video-icon-btn__label {
        display: none;
    }

    @media (min-width: 520px) {
        .edit-video-icon-btn__label {
            display: inline;
        }
    }

    .edit-video-shell {
        display: grid;
        grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
        gap: 1.25rem;
        align-items: stretch;
        padding: 1.25rem 1.5rem 0;
    }

    @media (max-width: 991px) {
        .edit-video-shell {
            grid-template-columns: 1fr;
        }

        .edit-video-aside {
            order: -1;
        }
    }

    .edit-video-main {
        display: flex;
        flex-direction: column;
        min-width: 0;
        min-height: 100%;
    }

    .edit-video-aside {
        display: flex;
        flex-direction: column;
        min-width: 0;
    }

    .edit-video-aside .edit-video-panel--media {
        flex: 1;
    }

    .edit-video-panel {
        background: #fff;
        border: 1px solid #e8eaf0;
        border-radius: 14px;
        padding: 1.25rem 1.35rem;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
    }

    .edit-video-panel--form {
        display: flex;
        flex-direction: column;
        flex: 1;
        height: 100%;
    }

    .edit-video-description {
        display: flex;
        flex-direction: column;
        flex: 1;
        min-height: 0;
        margin-bottom: 0 !important;
    }

    .edit-video-description__field {
        display: flex;
        flex: 1;
        min-height: 8rem;
    }

    .edit-video-description__field textarea {
        flex: 1;
        width: 100%;
        min-height: 8rem;
        resize: none;
    }

    .edit-video-description .char-counter {
        display: block;
        margin-top: 0.4rem;
        text-align: right;
    }

    @media (max-width: 991px) {
        .edit-video-panel--form {
            height: auto;
        }

        .edit-video-description__field,
        .edit-video-description__field textarea {
            flex: none;
            min-height: 8rem;
            height: 8rem;
        }
    }

    .edit-video-panel__title {
        margin: 0 0 1rem;
        font-size: 0.8125rem;
        font-weight: 600;
        letter-spacing: 0.04em;
        text-transform: uppercase;
        color: #5c6370;
    }

    .edit-video-replace {
        margin-top: 0.75rem;
        background: transparent;
        border: 0;
        padding: 0;
        color: var(--v-theme-primary, #1976d2);
        font-size: 0.875rem;
        cursor: pointer;
    }
    .edit-video-upload-progress {
        margin: 0.75rem 0 0;
        font-size: 0.875rem;
    }
    .edit-video-player {
        position: relative;
        width: 100%;
        aspect-ratio: 16 / 9;
        border-radius: 12px;
        overflow: hidden;
        background: #111318;
        margin-bottom: 1rem;
    }

    .edit-video-player iframe {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        border: 0;
    }

    .edit-video-grid-2 {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 1rem 1.25rem;
    }

    @media (max-width: 480px) {
        .edit-video-grid-2 {
            grid-template-columns: 1fr;
        }
    }

    .edit-video-panel .form-group {
        margin-bottom: 1.1rem;
    }

    .edit-video-panel .form-group:last-child {
        margin-bottom: 0;
    }

    .edit-video-footer {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-end;
        gap: 0.75rem;
        margin-top: 1.5rem!important;
        padding: 1.25rem 1.5rem 0;
        border-top: 1px solid #e8eaf0;
    }

    .edit-video-upload-wrap :deep(.image-upload-input) {
        margin-top: 0.25rem;
    }

    .form-group.imageCoverPreview.edit-video-cover {
        text-align: center;
        position: relative;
        width: 100%;
        margin-bottom: 1rem;
        border-radius: 12px;
        overflow: hidden;
        cursor: pointer;
    }

    img.coverVideo {
        width: 100% !important;
        max-width: 100%;
        height: auto;
        margin: 0;
        display: block;
        aspect-ratio: 16 / 9;
        filter: brightness(0.55);
        border-radius: 12px;
        box-shadow: 0 8px 24px rgba(37, 8, 145, 0.12);
        object-fit: cover;
        min-height: 0;
        max-height: none;
    }
    
    .video-placeholder {
        background: linear-gradient(135deg, #e8ecff 0%, #c5d0f0 100%);
        width: 100% !important;
        aspect-ratio: 16 / 9;
        min-height: 0;
        max-height: none;
        margin: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 12px;
        box-shadow: 0 8px 24px rgba(37, 8, 145, 0.1);
        cursor: pointer;
        transition: all 0.3s ease;
        position: relative;
        filter: brightness(0.92);
    }
    
    .video-placeholder:hover {
        box-shadow: 0px 0px 15px 2px rgba(0, 0, 0, 0.3);
        transform: translateY(-2px);
    }
    
    .video-placeholder-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 1rem;
        text-align: center;
        position: relative;
        z-index: 1;
        width: 100%;
        height: 100%;
    }
    
    .video-placeholder-icon {
        font-size: 3rem;
        color: #250891;
        opacity: 0.85;
    }
    
    .video-placeholder-text {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
    }
    
    .video-placeholder-title {
        font-size: 1.1rem;
        font-weight: 600;
        color: #1a1d26;
    }
    
    .video-placeholder-subtitle {
        font-size: 0.8125rem;
        color: #5c6370;
    }
    
    .video-placeholder .info {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        cursor: pointer;
        z-index: 5;
    }
    
    .video-placeholder .info svg {
        font-size: 50px !important;
        color: white !important;
        text-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
    }

    .edit-video-cover .info {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        cursor: pointer;
        z-index: 2;
    }

    .edit-video-cover .info svg {
        width: 3rem !important;
        height: 3rem !important;
        font-size: 3rem !important;
        color: #fff !important;
        filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.35));
    }
</style>
